import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

type P = {
  firstName?: null | string;
  lastName?: null | string;
};

export const useGetUserFirstNameWithFallback = () => {
  const { t } = useTranslation(['translationReactUtilities']);

  return useCallback(
    ({ firstName, lastName }: P = {}) => {
      if (firstName) {
        return firstName;
      }

      return lastName ? '' : t('Unknown');
    },
    [t],
  );
};
